// extracted by mini-css-extract-plugin
export var info = "support-module--info--62e9b";
export var subtitle = "support-module--subtitle--123f5";
export var support = "support-module--support--8ced4";